import { render, staticRenderFns } from "./TwProcessGroupListIpRequest.vue?vue&type=template&id=1c0f5c23&scoped=true&"
import script from "./TwProcessGroupListIpRequest.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListIpRequest.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListIpRequest.vue?vue&type=style&index=0&id=1c0f5c23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f5c23",
  null
  
)

export default component.exports